var render = function render(){var _vm=this,_c=_vm._self._c;return _c('edit-aprovacao',{ref:"editAprovacao",attrs:{"idAprovacao":_vm.idLiberacao},on:{"showOverlay":(status) => this.$emit('showOverlay', status),"fecharedit":() => this.edit = true,"executou":(r) => { if (r.status === 'success') this.atualizarRegistro(r.id) }}})
}
var staticRenderFns = []

export { render, staticRenderFns }